











import Vue from "vue";
import { mapState } from "vuex";
import Footer from "../components/master/Footer.vue";
import PasswordInput from "../components/common/passwordInput.vue";
import AbpBase from "../lib/abpbase";

export default AbpBase.extend({
  components: {
    Footer,
    PasswordInput,
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.query).length !== 0) {
      next((vm) => {
        (vm as any).getParameters(to.query.Id, to.query.ConfirmationCode);
      });
    }
  },
  data() {
    return {
      confirmEmailAddressModel: {
        id: 0,
        confirmationCode: "",
      },
      confirmCompleted: false,
      showSuccess: false,
      showError: false,
      message: "",
    };
  },
  computed: {
    ...mapState("session", ["user"]),
  },
  mounted() {
    setTimeout(() => {
      this.confirmEmailAddress();
    }, 100);
  },
  methods: {
    getParameters(id, confirmationCode) {
      this.confirmEmailAddressModel.id = id;
      this.confirmEmailAddressModel.confirmationCode = confirmationCode;
    },
    confirmEmailAddress() {
      let context = this as any;
      context.$Spin.show();

      let requestData = {
        id: context.confirmEmailAddressModel.id,
        confirmationCode: context.confirmEmailAddressModel.confirmationCode,
      };

      context.$store.dispatch("account/confirmEmailAddress", requestData).then((response) => {
        setTimeout(() => {
          context.$Spin.hide();
        }, 500);

        if (response.success === true) {
          context.$store.dispatch("account/setEmailConfirmed", { emailAddress: response.confirmedEmailAddress });
          context.$router.push({ name: "login" });
        } else {
          context.showError = true;
          context.message = response.message;
        }
      });
    },
  },
});
